export enum EPaymentItemCategory {
  REGULAR = "regular",
  REIMBURSEMENT = "reimbursement",
  KIT = "kit",
}

export const getPaymentItemCategoryLabel = (
  category?: EPaymentItemCategory | string
) => {
  if (!category) {
    return "-";
  }
  return category.charAt(0).toUpperCase() + category.slice(1);
};
